import React from "react";
import styles from "assets/jss/material-dashboard-react/components/tablebaocaoStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Config from "conFig.js";
const BCXehopdongtable = React.memo(function BCXehopdongtable(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [sophuongtien, setSophuongtien] = React.useState(0);
  const [sophuongtien_duoi9c, setSophuongtien_duoi9c] = React.useState(0);
  const [sophuongtien_9_25c, setSophuongtien_9_25c] = React.useState(0);
  const [sophuongtien_tren25c, setSophuongtien_tren25c] = React.useState(0);
  const [sochuyenxethuchien, setSochuyenxethuchien] = React.useState(0);
  const [sokhachvanchuyen, setSokhachvanchuyen] = React.useState(0);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    if (thangnam) {
      var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
      var url =
        Config.backend +
        "/api/Phuongtien/bcslthxehodong?thang=" +
        thang +
        "&username=" +
        username;
      fetch(url, obj)
        .then((res) => res.json())
        .then((data) => {
          if (data.length > 0) {
            setSophuongtien(data[0].sophuongtien);
            setSophuongtien_duoi9c(data[0].sophuongtien_duoi9c);
            setSophuongtien_9_25c(data[0].sophuongtien_9_25c);
            setSophuongtien_tren25c(data[0].sophuongtien_tren25c);
            setSochuyenxethuchien(data[0].sochuyenxethuchien);
            setSokhachvanchuyen(data[0].sokhachvanchuyen);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    }
  };
  React.useEffect(() => {
    getbaocao();
  }, [thangnam]);
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tablebc_th}>TT</th>
          <th className={classes.tablebc_th}>Chỉ tiêu</th>
          <th className={classes.tablebc_th}>Đon vị</th>
          <th className={classes.tablebc_th}>Số lượng</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tablebc_td}>1</td>
          <td className={classes.tablebc_td}>Số lượng phương tiện</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sophuongtien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Sức chứa dưới 9 chỗ</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sophuongtien_duoi9c}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Sức chứa từ 9-25 chỗ</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sophuongtien_9_25c}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}></td>
          <td className={classes.tablebc_td}>- Sức chứa từ trên 25 chỗ</td>
          <td className={classes.tablebc_td}>xe</td>
          <td className={classes.tablebc_td}>{sophuongtien_tren25c}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>2</td>
          <td className={classes.tablebc_td}>Số chuyến xe thực hiện</td>
          <td className={classes.tablebc_td}>chuyến</td>
          <td className={classes.tablebc_td}>{sochuyenxethuchien}</td>
        </tr>
        <tr>
          <td className={classes.tablebc_td}>3</td>
          <td className={classes.tablebc_td}>Sản lượng khách vận chuyển</td>
          <td className={classes.tablebc_td}>lượt khác</td>
          <td className={classes.tablebc_td}>{sokhachvanchuyen}</td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = renderTableBody();
  return (
    <div className={classes.table} style={{ height: "350px" }}>
      <table id="baocaoxehopdong" className={classes.tablebc}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

BCXehopdongtable.propTypes = {
  thangnam: PropTypes.object,
};
export default BCXehopdongtable;
